import React, { useEffect } from 'react'
import { useState } from 'react';
import '../Styles/Wargaming.css'
import Bwg from '../Assets/Bwg.png'
import Crosshair from '../Assets/Crosshair.png'
import Meeting from '../Assets/Meeting.jpeg'
import CoPresentOutlinedIcon from '@mui/icons-material/CoPresentOutlined';
import VideogameAssetIcon from '@mui/icons-material/VideogameAsset';
import LightbulbTwoToneIcon from '@mui/icons-material/LightbulbTwoTone';
import StackedBarChartIcon from '@mui/icons-material/StackedBarChart';
import Earth from '../Assets/Earth.png'
import Morse from '../Assets/Morse.png'
import Tank from '../Assets/Tank.png'
import {getAnalytics, logEvent} from "firebase/analytics";
import { Helmet } from 'react-helmet';

function Wargaming() {
    const analytics = getAnalytics();
    const [showEmail, setShowEmail] = useState(false);

    useEffect(() => {
        logEvent(analytics, 'Visit', { name: 'Wargaming Page' });
    }, []);

  return (
    <div className="Wargaming-container">
        <Helmet>
            <title>The Trehan | Wargaming</title>
            <meta name='description' content='Experience business simulation inspired by military wargaming. Test strategies, hedge risks, and build executive resilience against real-world disruptions.' data-react-helmet="true"/>
            <meta name="theme-color" content="#000000" data-react-helmet="true"/>
            <meta name='keywords' content="business wargaming, strategy simulation, corporate wargames, executive decision making, business strategy testing, competitive strategy, crisis simulation, risk management, leadership training, military wargaming for business, strategic foresight, scenario planning, business resilience, organisational strategy, strategic thinking" data-react-helmet="true"/>  
            <link rel='canonical' href='/'/>
        </Helmet>
        <div className='Wargaming-landing'>
            <img className='Wargaming-landing-bwg' src={Bwg} alt='bwg'/>
            <div className='Wargaming-landing-right'>
                <p className='Wargaming-landing-business'>Business</p>
                <div className='Wargaming-landing-title-container'>
                    <h1 className='Wargaming-landing-title'>Wargame</h1>
                    <img className='Wargaming-landing-crosshair' src={Crosshair} alt='Crosshair'/>
                </div>
                <p className='Wargaming-landing-sasa'>Stay Agile, Stay Alive</p>
                <p className='Wargaming-landing-trehz'>TréHz</p>
                <p className='Wargaming-landing-para'>Business simulation based on military wargaming techniques. Explore ideas, Test plans, hedge bets and sharpen executive skills to survive internal and external shocks/disruptions.</p>
            </div>
            <div className='Wargaming-landing-pallet'>
                <div className='Wargaming-landing-pallet-blue1'></div>
                <div className='Wargaming-landing-pallet-blue2'></div>
                <div className='Wargaming-landing-pallet-grey'></div>
            </div>
        </div>
        <div className='Wargaming-meeting-slide'>
            <img className='Wargaming-meeting-image'alt='meeting' src={Meeting}/>
            <div className='Wargaming-meeting-quote-box'>
                <p className='Wargaming-meeting-quote'>Plan your move before others make theirs</p>
                <div className='Wargaming-landing-pallet'>
                    <div className='Wargaming-landing-pallet-blue1'></div>
                    <div className='Wargaming-landing-pallet-blue2'></div>
                    <div className='Wargaming-landing-pallet-grey'></div>
                </div>
                <p className='Wargaming-meeting-quote quote2'>"Predictability has a huge premium these days"</p>
                <p className='Wargaming-meeting-quote author'>External Affairs Minister S. Jaishankar</p>
            </div>
        </div>
        <div className='Wargaming-benefits-slide'>
            <div className='Wargaming-benefits-top'>
                <img className='Wargaming-benefits-img' src={Tank} alt='tank'/>
                <p className='Wargaming-benefits-toptext'>Business Wargaming helps businesses and their executives respond to disruptions with <br/> <b>Speed, Clarity and Control.</b></p>
            </div>
            <div className='Wargaming-benefits-bottom'>
                <div className='Wargaming-benefits'>
                    <p className='Wargaming-benefits-title'>Qualitative Benefits</p>
                    <ul>
                        <li>Clarity of Strategic Options</li>
                        <li>Shared Situational Awareness</li>
                        <li>Exposed Blind Spots</li>
                        <li>Decision-Readiness</li>
                        <li>Cross-Functional Insights</li>
                        <li>Crisis Management</li>
                    </ul>
                </div>
                <div className='Wargaming-benefits'>
                    <p className='Wargaming-benefits-title'>Behavioural Benefits</p>
                    <ul>
                        <li>Boardroom foresight</li>
                        <li>Corporate resilience</li>
                        <li>Team alignment</li>
                        <li>Agile decision-making</li>
                        <li>Personnel Behavioural Insights</li>
                        <li className='Wargaming-benefits-vc'><b>(Key for VCs & CEOs to evaluate who to invest in)</b></li>
                    </ul>
                </div>
            </div>
        </div>
        
        <div className='Wargaming-info-slide'>
            <div className='Wargaming-info-slide-containter'>
                <div className='Wargaming-info-box'>
                    <div className='Wargaming-info-icon-box'>
                        <CoPresentOutlinedIcon style={{fontSize: '5rem', color:'#D2FDFA'}}/>
                    </div>
                    <p className='Wargaming-info-title'>Briefing Session</p>
                    <p className='Wargaming-info-desc'>1-2 days before the game day.</p>
                </div>
                <hr class="dotted-line" />
                <div className='Wargaming-info-box'>
                    <div className='Wargaming-info-icon-box'>
                        <VideogameAssetIcon style={{fontSize: '5rem', color:'#D2FDFA'}}/>
                    </div>
                    <p className='Wargaming-info-title'>Game Day</p>
                    <p className='Wargaming-info-desc'>Full working day of War game, going through rounds of back and forth battle moves by teams competing.</p>
                </div>
                <hr class="dotted-line" />
                <div className='Wargaming-info-box'>
                    <div className='Wargaming-info-icon-box'>
                        <LightbulbTwoToneIcon style={{fontSize: '5rem', color:'#D2FDFA'}}/>
                    </div>
                    <p className='Wargaming-info-title'>De-briefing Session</p>
                    <p className='Wargaming-info-desc'>Overview of the general game direction de-briefed to the participants.</p>
                </div>
                <hr class="dotted-line" />
                <div className='Wargaming-info-box'>
                    <div className='Wargaming-info-icon-box'>
                        <StackedBarChartIcon style={{fontSize: '5rem', color:'#D2FDFA'}}/>
                    </div>
                    <p className='Wargaming-info-title'>Executive Report</p>
                    <p className='Wargaming-info-desc'>A detailed report of the game score, personnel, vulnerability & risk assessment report, action plans, and suggestions  handed over.</p>
                </div>
            </div>
            
        </div>
        <div className='Wargaming-quote-slide'>
            <img className='Wargaming-quote-image'alt='earth' src={Earth}/>
            <div className='Wargaming-quote-box'>
                <img className='Wargaming-morse'alt='morse' src={Morse}/>
                <p className='Wargaming-quote'>"If you must be a bloody fool,<br/> be one quickly!"</p> 
                <p className='Wargaming-source'>Field Marshal Sam Manekshaw</p>
                <img className='Wargaming-morse'alt='morse' src={Morse}/>
                <button className='Wargaming-enquire-button' onClick={() => setShowEmail(!showEmail)}>Enquire Now</button>
                {showEmail && (<a href="mailto:hartaj@thetrehan.com" className="Wargaming-email">hartaj@thetrehan.com</a>)}
            </div>
        </div>
        
    </div>
  )
}

export default Wargaming